// extracted by mini-css-extract-plugin
export default {"submit":"SubmitButton-module_submit_ded22b"};